import {Component, EventEmitter, Input, Output} from '@angular/core';
import {map, Observable} from 'rxjs';
import * as tus from 'tus-js-client';
import {AuthService} from '@/services/auth.service';
import {EnvironmentService} from '@/services/EnvironmentService';

interface FileUploadError {
  name: string;
  message: string;
}

@Component({
	selector: 'file-uploader',
	templateUrl: './file-upload.component.html',
	host: {'class': 'file-uploader-component'}
})
export class FileUploadComponent {
  readonly MAX__SIZE_MB: number = 100;
  readonly MAX_SIZE: number = this.MAX__SIZE_MB * 1024 * 1024;

  // enables two-way binding on the model
  @Output()
  fileChange: EventEmitter<File[]> = new EventEmitter<File[]>();

  @Output()
  isQueued: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  isValid: EventEmitter<boolean> = new EventEmitter<boolean>();

	files: any[] = [];
  queuedUploads: any[] = [];

  public fileUploadErrors: FileUploadError[] = [];

	nonUniqueFilename: boolean = false;
  Url: string;

	@Input()
	file: any;

  @Input()
  getAttachmentPrefix?: () => string;

	@Input()
  set errors(obs: Observable<string>) {
	  obs.pipe(map(k => {
      if (k === 'payload_too_large') {
        return { name: 'max_size_server', message: `File sizes exceeds server limit.`};
      }
      return { name: 'server_error', message: `Upload failed. Unknown cause.` };
    })).subscribe(s => {
      if (this.fileUploadErrors.findIndex(e => e.name !== s.name) === -1) {
        this.fileUploadErrors.push(s);
      }
    });
  }

  constructor(protected authService: AuthService, environment: EnvironmentService) {
    this.Url = environment.APIBASEURL + '/uploads?ngsw-bypass';
  }

  uploadFile(newFiles: FileList): void {
    const authToken = this.authService.accessToken.getValue();
    for (let index = 0; index < newFiles.length; index++) {
      const file = newFiles.item(index);
      if (file.size > this.MAX_SIZE) {
        this.fileUploadErrors.push({ name: 'max_size', message: `File ${file.name} exceeds size limit (${this.MAX__SIZE_MB}MB).`});
        continue;
      }

      const filePath = this.getAttachmentPrefix() ? this.getAttachmentPrefix() + file.name : file.name;
      const upload = new tus.Upload(file, {
        endpoint: this.Url,
        headers: {
          Authorization: 'Bearer ' + authToken
        },
        retryDelays: [0, 3000, 5000, 10_000, 20_000],
        chunkSize: 1024 * 1024 * 3,
        metadata: {
          filename: filePath,
          filetype: file.type
        },
        onError: (err) => {
          console.error(err);
        },
        onProgress: (bytesUploaded, bytesTotal) => {
          this.queuedUploads.find(u => u.name === file.name).progress
            = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
        },
        onSuccess: () => {
          this.queuedUploads = this.queuedUploads.filter(u => u.name !== file.name);
          this.files.push({ filename: file.name, path: filePath, file });
          this.fileChange.emit(this.files);
          this.isQueued.emit(this.queuedUploads.length > 0);
        },
      });

      upload.start();
      this.queuedUploads.push({ name: file.name, progress: '0', size: file.size });
      this.isQueued.emit(true);
    }

    // clear current errors on upload
    // this.fileUploadErrors = [];

    // for (let index = 0; index < newFiles.length; index++) {
		// 	const element = newFiles[index];
		// 	if (!this.files.find((file: File) => file.name === element.name)) {
		// 		this.files.push(element);
		// 	} else {
		// 		this.nonUniqueFilename = true;
		// 	}
		// }

    // this.totalSize = this.files.reduce((acc: number, currentValue: File) => acc + currentValue.size, 0);
    // if (this.totalSize > this.MAX_SIZE) {
    //   this.fileUploadErrors.push({ name: 'max_size', message: `File exceeds size limit (${this.MAX__SIZE_MB}MB).`});
    // }

    // this.isValid.emit(this.fileUploadErrors.length === 0);
    // this.fileChange.emit(this.files);
	}

	deleteAttachment(index: number): void {
		const delFiles: File[] = this.files.splice(index, 1);
		this.fileChange.emit(this.files);
		if (delFiles.length === 0) {
		  // something went wrong, so return
      return;
    }

		this.isValid.emit(this.fileUploadErrors.length === 0);
	}
}
